// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lq-1";
export var stateContainer = "_lq-0";